<template>
  <vue-spinner size="55"/>
</template>

<script>
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'BootSpinner',
  components: { VueSpinner }
}
</script>

<style>
html {
  width: 100%;
  height: 100%;
  margin: 0
}

body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
}

#app {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: Gordita, Helvetica, Arial, sans-serif;
  line-height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}
</style>
